import API from "helpers/api";
import { Apis } from "services/api";
import { getAPIResponse } from "helpers/getApiResponse";
import { defaultPageSize } from "helpers/utils";

export const getFeedbackUsers = async (siteAppId) => {
	try {
		let response = await API.get(`${Apis.Feedback}/users?siteAppId=${siteAppId}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getFeedbackList = async ({
	siteAppId,
	pageNumber = "1",
	pageSize = defaultPageSize(),
	search = "",
	sortField = "",
	sortOrder = "",
	fromDate = "",
	toDate = "",
	siteDepartmentID = "",
	siteDepartmentIds = [],
	statusType = "",
	feedbackStatusID = "",
	myFeedback = true,
	userId = "",
}) => {
	try {
		// Build department IDs query string
		let deptQuery = "";
		if (siteDepartmentIds && siteDepartmentIds.length > 0) {
			// Use array format for multiselect
			deptQuery = siteDepartmentIds.map(id => `siteDepartmentIDs=${id}`).join('&');
			if (deptQuery) deptQuery = `&${deptQuery}`;
		} else if (siteDepartmentID) {
			// Backward compatibility for single department
			deptQuery = `&siteDepartmentID=${siteDepartmentID}`;
		}

		let response = await API.get(
			`${Apis.Feedback}?siteAppId=${siteAppId}&fromDate=${fromDate}&toDate=${toDate}${deptQuery}&feedbackStatusID=${feedbackStatusID}&statusType=${statusType}&myFeedback=${myFeedback}&userId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}&search=${search}&sortField=${sortField}&sortOrder=${sortOrder}`
		);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getCountOfFeedbackList = async ({
	siteAppId,
	search = "",
	fromDate = "",
	toDate = "",
	siteDepartmentID = "",
	siteDepartmentIds = [],
	myFeedback = true,
	feedbackStatusID = "",
	statusType = "",
	userId = "",
}) => {
	try {
		// Build department IDs query string
		let deptQuery = "";
		if (siteDepartmentIds && siteDepartmentIds.length > 0) {
			// Use array format for multiselect
			deptQuery = siteDepartmentIds.map(id => `siteDepartmentIDs=${id}`).join('&');
			if (deptQuery) deptQuery = `&${deptQuery}`;
		} else if (siteDepartmentID) {
			// Backward compatibility for single department
			deptQuery = `&siteDepartmentID=${siteDepartmentID}`;
		}

		let response = await API.get(
			`${Apis.Feedback}/count?siteAppId=${siteAppId}&fromDate=${fromDate}&toDate=${toDate}${deptQuery}&feedbackStatusID=${feedbackStatusID}&search=${search}&statusType=${statusType}&myFeedback=${myFeedback}&userId=${userId}`
		);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const postNewFeedback = async (payload) => {
	try {
		let response = await API.post(`${Apis.Feedback}`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};
